import { PropsWithChildren } from "react";
import { ReportsProvider } from "../../providers/ReportsProvider";
import ReportsTabs from "./ReportTabs";

export type StringOverrides = {
  profitBeforeTaxesLabel: string;
  netProfitLabel: string;
};
type ReportsProps = PropsWithChildren & {
  stringOverrides?: StringOverrides;
  withDownloadButton?: boolean;
};

const Reports = ({
  children,
  stringOverrides,
  withDownloadButton,
  ...rest
}: ReportsProps) => {
  return (
    <ReportsProvider {...rest}>
      {children}
      <ReportsTabs
        stringOverrides={stringOverrides}
        withDownloadButton={withDownloadButton}
      />
    </ReportsProvider>
  );
};

export { Reports };
